import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
}

const AdminConfirmDialog: React.FC<Props> = ({ isOpen, onClose, onConfirm, title, message }) => (
  <AnimatePresence>
    {isOpen && (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[900] bg-black/30 backdrop-blur-sm"
          onClick={onClose}
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 10 }}
          transition={{ duration: 0.2 }}
          className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[950] w-full max-w-sm bg-white dark:bg-[#111] border border-black/[0.06] dark:border-white/[0.06] rounded-2xl p-6 shadow-2xl"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-red-500/10 flex items-center justify-center">
              <AlertTriangle size={18} className="text-red-500" />
            </div>
            <h3 className="text-sm font-bold">{title}</h3>
          </div>
          <p className="text-[12px] text-black/50 dark:text-white/50 mb-6 leading-relaxed">{message}</p>
          <div className="flex gap-2 justify-end">
            <button onClick={onClose} className="px-5 py-2.5 text-[10px] font-bold uppercase tracking-[0.15em] text-black/40 dark:text-white/40 hover:text-black dark:hover:text-white transition-colors">
              Cancel
            </button>
            <button onClick={() => { onConfirm(); onClose(); }} className="px-5 py-2.5 bg-red-500 text-white text-[10px] font-bold uppercase tracking-[0.15em] rounded-xl hover:bg-red-600 transition-colors">
              Delete
            </button>
          </div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);

export default AdminConfirmDialog;
